import React from 'react';

import OutsideWallModel from './OutsideWallModel';
import InsideWallModel from './InsideWallModel';
import TrimModel from './TrimModel';

const BackWall = () => {

    return (
        <>
            <OutsideWallModel />
            <InsideWallModel />
            <TrimModel />
        </>
    )
}

export default BackWall